import React from 'react';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { Site, SiteConfig } from '@99designs/common/apps/global-nav/lib/Site';
import { BackendSubscriptionClientProvider } from 'common/ApolloClient/BackendSubscriptionClientContext';
import { ErrorBoundary } from 'common/ErrorBoundary';
import { IntlProvider } from 'common/I18n/IntlContext';
import ViewerProviderQuery from 'common/Viewer/ViewerContext';
import { SiteProvider } from 'common/SiteContext';
// @ts-ignore
import messages from 'GlobalNavMessages'; // eslint-disable-line import/no-unresolved
import Routes from 'routes';
import { SnackbarProvider } from './common/FloatingAlert/hooks';
import { Helmet } from 'react-helmet-async';

interface Props {
    language: string;
    siteConfig: SiteConfig;
    backendSubscriptionClient?: SubscriptionClient;
}

class App extends React.Component<Props> {
    render() {
        const site = new Site(this.props.siteConfig);
        return (
            <IntlProvider locale={this.props.language} messages={messages}>
                <ErrorBoundary site={site}>
                    <SnackbarProvider>
                        <BackendSubscriptionClientProvider
                            value={this.props.backendSubscriptionClient}
                        >
                            <ViewerProviderQuery>
                                <SiteProvider site={site}>
                                    <Helmet
                                        titleTemplate="%s | 99designs"
                                        defaultTitle="99designs"
                                    />
                                    <Routes site={site} />
                                </SiteProvider>
                            </ViewerProviderQuery>
                        </BackendSubscriptionClientProvider>
                    </SnackbarProvider>
                </ErrorBoundary>
            </IntlProvider>
        );
    }
}

export default App;
